const accessRoute = {
  SCORE: {
    path: "/score",
  },
};
export default accessRoute;
